import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import { useBusinessData } from '../../context/BusinessContext';
import '../../css/HiringSection.css';

const HiringSection = () => {
  const { getData, hasData, getImageUrl } = useBusinessData();
  
  // Get careers/hiring background image or use default color if not available
  const hiringBgImage = getImageUrl('images.backgrounds.careers', '');
  
  // Create inline style for background image if available
  const hiringBgStyle = hiringBgImage 
    ? { backgroundImage: `linear-gradient(rgba(0, 0, 60, 0.7), rgba(0, 0, 60, 0.7)), url('${hiringBgImage}')` }
    : {};
    
  // Get job openings from the data, if available
  const jobOpenings = getData('careers.openPositions', []);
  
  // Only render if we have job openings or careers content
  if (!hasData('careers') && jobOpenings.length === 0) {
    return null;
  }

  return (
    <div className="hiring-section" style={hiringBgStyle}>
      <div className="container">
        <div className="hiring-content">
          <h2>{getData('ui.about.hiringSection.title', "We're Hiring!")}</h2>
          <p className="hiring-subtitle">
            {getData('ui.about.hiringSection.subtitle', 'Join our team and grow your career with us')}
          </p>
          
          {jobOpenings.length > 0 ? (
            <div className="job-openings">
              <h3>Current Openings</h3>
              <div className="job-grid">
                {jobOpenings.map((job, index) => (
                  <div className="job-card" key={index}>
                    <div className="job-icon">
                      <FontAwesomeIcon icon={
                        job.department === 'Engineering' ? solidIcons.faBriefcase :
                        job.department === 'Sales' ? solidIcons.faHandshake :
                        job.department === 'HR' ? solidIcons.faUsers :
                        solidIcons.faBuilding
                      } />
                    </div>
                    <h4>{job.title}</h4>
                    <p className="job-location">{job.location}</p>
                    <p className="job-department">{job.department}</p>
                    <p className="job-type">{job.type}</p>
                    <Link to={`/careers/${index}`} className="job-apply-btn">{getData('ui.global.applyNowButton', 'Apply Now')}</Link>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="no-openings">
              <p>{getData('ui.about.hiringSection.noOpeningsMessage', 'We don\'t have specific openings right now, but we\'re always looking for talented individuals.')}</p>
              <p>{getData('ui.about.hiringSection.contactMessage', 'Send us your resume and we\'ll keep it on file for future opportunities.')}</p>
            </div>
          )}
          
          <div className="hiring-cta">
            <Link to="/contact" className="cta-button">
              {getData('ui.about.hiringSection.ctaText', 'Get in Touch')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HiringSection; 